import React, { useState } from 'react';
import { Button, CustomCarousel, Modal, ModalBody, ModalFooter } from '../../../../lib/components';
import PropTypes from "prop-types";

import styles from "../../../../assets/scss/pages/news.module.scss";
import moment from 'moment';

const FullNewsModal = (props) => {
  const { isOpen, toggle, item } = props;

  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  const [swiper, setSwiper] = useState(null);

  const images = item?.images
    ?.filter((i) => i)
    ?.map((i) => ({
      original: i,
      thumbnail: i,
    })) ?? [];

  const handleClickItem = (index) => {
    setSelectedImage(index);
    setShowImageModal(true);
  };

  const handleCloseModal = () => {
    setSelectedImage(0);
    setShowImageModal(false);
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} size="lg" className={styles.fullNewsModal}>
        {item ? (
          <div className={styles.fnmContainer}>
            <div className={styles.fnmHeader}>
              <div className={styles.fnmTitleContainer}>

                <h1 className={styles.fnmTitle}>{item.title}</h1>
                <div className={styles.fnmDate}>
                  Publié le {moment(item?.date.toDate()).format("DD/MM/YYYY")}
                </div>
              </div>

              <div className={styles.fnmTag} style={{backgroundColor: item.type === "national" ? "#E49F9F" : item.type != undefined ? "#F9DEC9" : "#99B2DD"}}>
                {item.type === "national" ? "Actualité Nationale" : item.type != undefined ? "Actualité Régionale" : "Actualité Locale"}
              </div>
            </div>

            <div className={`${styles.fnmQuillContainer} ql-container ql-snow`}>
              <div className={`${styles.fnmQuillEditor} ql-editor`} dangerouslySetInnerHTML={{ __html: item.content }}></div>
            </div>

            {images.length ? (
              <div className={styles.fnmCarouselContainer}>
                <CustomCarousel
                  items={images}
                  renderItem={({ item, index }) => (
                    <div className={styles.fnmCarouselImg} key={index} onClick={() => handleClickItem(index)}>
                      <img src={item.thumbnail} />
                    </div>
                  )}
                  numberPerView={"auto"}
                  type={"basic"}
                  sendSwiper={(e) => setSwiper(e)}
                />
              </div>
            ) : null}
          </div>
        ) : null}
      </Modal>
      {images.length ? (
        <Modal
          className={styles.fnmImagesModal}
          isOpen={showImageModal} 
          toggle={handleCloseModal} 
          size={"xl"}
        >
          <ModalBody className={styles.fnmModalBody} style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <CustomCarousel
              items={images}
              renderItem={({ item, index }) => (
                <div className={styles.fnmFocusImage} key={index}>
                  <img src={item.thumbnail} />
                </div>
              )}
              numberPerView={1}
              type={"basic"}
              sendSwiper={(e) => setSwiper(e)}
              initialSlide={selectedImage}
            />
          </ModalBody>
          <ModalFooter className={styles.fnmModalFooter}>
            <Button className={styles.fnmCloseImagesModalButton} onClick={handleCloseModal}>Fermer</Button>
          </ModalFooter>
        </Modal>
      ) : null}
    </>
  );
};

FullNewsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
};

export default FullNewsModal;